import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr2019',
    ecrans: ['00-2']
});
